import Flash from '@/components/flash';
import { Head, usePage } from '@inertiajs/react';

interface FullscreenLayoutProps {
  children: React.ReactNode;
  flash: {
    notice?: string;
    error?: string;
  };
  pageTitle?: string;
}

export default function FullscreenLayout({ children, flash, pageTitle }: FullscreenLayoutProps) {
  const { props } = usePage<{ pageTitle?: string }>();
  const title = pageTitle || props.pageTitle || 'Iniciador';

  return (
    <>
      <Head title={title} />
      <div className="min-h-dvh w-full">
        <Flash {...flash} />
        {children}
      </div>
    </>
  );
}
